import { createReducer } from "@reduxjs/toolkit";
import { resetRetrieveFundingRequestEligibility, retrieveFundingRequestEligibility } from "./retrieve-funding-request-eligibility";
import type { RetrievalState } from "@redux/state/shared-types";
import type { FundingRequestEligibilityVM } from "@shared-kernel/application/ports/student/student-repository";

const initialState: RetrievalState<FundingRequestEligibilityVM | null> = { fetching: "idle", data: null };

export const retrieveFundingRequestEligibilityReducer = createReducer<RetrievalState<FundingRequestEligibilityVM | null>>(
  initialState,
  builder => {
    builder.addCase(retrieveFundingRequestEligibility.fulfilled, (state, { payload }) => {
      return {
        ...state,
        data: payload,
        fetching: "success",
      };
    });
    builder.addCase(retrieveFundingRequestEligibility.pending, state => {
      return {
        ...state,
        fetching: "pending",
      };
    });
    builder.addCase(retrieveFundingRequestEligibility.rejected, state => {
      return {
        ...state,
        fetching: "failed",
      };
    });
    builder.addCase(resetRetrieveFundingRequestEligibility, () => {
      return initialState;
    });
  },
);
